import { hasControlChars } from '@hapana/shared/web/utils/article-slug.util'

export const sanitizeRedirectPath = (value: string | null | undefined): string | null => {
  if (!value) {
    return null
  }
  // Only same-origin absolute paths. "//host" and "https://host" are browser-navigable
  // elsewhere, and the param is now reachable from any emailed link.
  if (!value.startsWith('/') || value.startsWith('//')) {
    return null
  }
  if (hasControlChars(value)) {
    return null
  }

  return value
}

export const buildRedirectSearch = (path: string | null): string =>
  path ? `?redirect=${encodeURIComponent(path)}` : ''
